<template>
	<div class="sdfjsf8">
		<j-base-select
			class="xs mr2"
			:size="size"
			:status="status"
			:value="computedDay"
			:options="dayOptions"
			:placeholder="dayPlaceholder"
			:allowSelectNothing="false"
			:readonly="readonly"
			@input="
				day = $event
				onInput()
			"
			@focus="$emit('focus')"
			@blur="$emit('blur')"
		/>
		<j-base-select
			class="xs mr2"
			:size="size"
			:status="status"
			:value="computedMonth"
			:options="monthOptions"
			:placeholder="monthPlaceholder"
			:allowSelectNothing="false"
			:readonly="readonly"
			@input="
				month = $event
				onInput()
			"
			@focus="$emit('focus')"
			@blur="$emit('blur')"
		/>
		<j-base-select
			class="xs"
			:size="size"
			:status="status"
			:value="computedYear"
			:options="yearOptions"
			:placeholder="yearPlaceholder"
			:allowSelectNothing="false"
			:readonly="readonly"
			@input="
				year = $event
				onInput()
			"
			@focus="$emit('focus')"
			@blur="$emit('blur')"
		/>
	</div>
</template>

<script>
import dayjs from "dayjs"
import JBaseSelect from "../JBaseSelect/"

export default {
	name: "j-input-date-of-birth",
	// inheritAttrs: false,
	components: { JBaseSelect },

	props: {
		readonly: {
			default: false
		},
		value: {
			validator(value) {
				return (
					value === null || typeof value === "string" || dayjs(value).isValid()
				)
			},
			required: true,
			default: null
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					["xsmall", "small", "medium", "large", "xlarge"].includes(val)
				)
			}
		},
		status: {
			required: false,
			default: null,
			validator(val) {
				return val === null || ["error", "success", "warning"].includes(val)
			}
		},
		dayPlaceholder: {
			type: String,
			required: false,
			default: "Day"
		},
		monthPlaceholder: {
			type: String,
			required: false,
			default: "Month"
		},
		yearPlaceholder: {
			type: String,
			required: false,
			default: "Year"
		},
		daysNames: {
			type: Array,
			required: false,
			default: () => [
				"1",
				"2",
				"3",
				"4",
				"5",
				"6",
				"7",
				"8",
				"9",
				"10",
				"11",
				"12",
				"13",
				"14",
				"15",
				"16",
				"17",
				"18",
				"19",
				"20",
				"21",
				"22",
				"23",
				"24",
				"25",
				"26",
				"27",
				"28",
				"29",
				"30",
				"31"
			]
		},
		monthsNames: {
			type: Array,
			required: false,
			default: () => [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December"
			]
		},
		maxAge: {
			type: Number,
			required: false,
			default: 150
		},
		minAge: {
			type: Number,
			required: false,
			default: 0
		}
	},

	data() {
		return {
			day: this.getDayFromValue(),
			month: this.getMonthFromValue(),
			year: this.getYearFromValue(),
			dayOptions: this.getDaysOptions(),
			monthOptions: this.getMonthsOptions(),
			yearOptions: this.getYearsOptions()
		}
	},

	computed: {
		computedDay() {
			return this.getDayFromValue()
		},
		computedMonth() {
			return this.getMonthFromValue()
		},
		computedYear() {
			return this.getYearFromValue()
		}
	},

	methods: {
		getDayFromValue() {
			if (dayjs(this.value).isValid() === false) return this.day
			return dayjs(this.value).format("DD")
		},

		getMonthFromValue() {
			if (dayjs(this.value).isValid() === false) return this.month
			return dayjs(this.value).format("MM")
		},

		getYearFromValue() {
			if (dayjs(this.value).isValid() === false) return this.year
			return dayjs(this.value).format("YYYY")
		},

		getYearsOptions() {
			let output = []
			let from = parseInt(
				dayjs()
					.subtract(this.maxAge + 1, "year")
					.format("YYYY")
			)
			let to = this.minAge
				? parseInt(
						dayjs()
							.subtract(this.minAge, "year")
							.format("YYYY")
				  )
				: parseInt(dayjs().format("YYYY"))

			while (from <= to) {
				output.push({
					name: `${from}`,
					value: from.toString().length === 1 ? `0${from}` : `${from}`
				})
				from++
			}

			return output
		},

		getMonthsOptions() {
			return this.monthsNames.map((item, index) => {
				return {
					name: item,
					value: index + 1 < 10 ? `0${index + 1}` : `${index + 1}`
				}
			})
		},

		getDaysOptions() {
			return this.daysNames.map((item, index) => {
				return {
					name: item,
					value: index + 1 < 10 ? `0${index + 1}` : `${index + 1}`
				}
			})
		},

		onInput() {
			let date = `${this.year}-${this.month}-${this.day}`
			date = dayjs(date).format("YYYY-MM-DD")

			// emit input only if date is valid date, otherwise return value
			if (dayjs(date).isValid() && this.day && this.month && this.year)
				this.$emit("input", date)
			else this.$emit("input", null)
		}
	}
}
</script>
<style src="./index.css" scoped />
